import mime from 'mime/lite';

export function getFileMimeType(file) {
  if (file.type) return file.type;

  return mime.getType(file.name) ?? 'application/octet-stream';
}
